import { Box, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2, InputLabel, MenuItem, Pagination, Paper, Tooltip, Select, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from "@mui/material"
import Dropdown from "../../reusable_components/components/Dropdown"
import MUIButton from "../../reusable_components/components/MUIButton"
import { useContext, useEffect, useState } from "react"
import { useGetManageEventListMutation, useGetPositionEventReportMutation, useJobDescForParticularClientMutation } from "../../redux/reports/reports.api"
import { useEventDropDownQuery, useGetClientDropdownQuery } from "../../redux/jobpostings/jobpostings.api"
import dayjs from 'dayjs'
import { useNavigate } from "react-router-dom"
import { SnackbarContext } from "../../reusable_components/components/Snackbar"
import { TableLoader } from "../../reusable_components/components/TableLoader"
import MUICancelButton from "../../reusable_components/components/MuiCancelButton"
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import CloseIcon from '@mui/icons-material/Close';
import FilterListIcon from '@mui/icons-material/FilterList';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DownloadIcon from "../../assets/Icons/DownloadIcon"
import CalendarIcon from "../../assets/Icons/CalendarIcon"
import SearchIconLg from "../../assets/Icons/SearchIcon"
import MuiDatePicker from "../../reusable_components/components/MuiDatePicker"

const ManageEventsReports = () => {

    const navigate = useNavigate()
    const [page, setPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [totalCount, setTotalCount] = useState(0)
    const [selectedClient, setSelectedClient] = useState(null)
    const [selectedClientId, setSelectedClientId] = useState([])
    const [selectedEvent, setSelectedEvent] = useState([])
    const [selectedJobPosting, setSelectedJobPosting] = useState("")
    const [jobPostingArr, setJobPostingArr] = useState([])
    const [manageEventsReportsList, setManageEventsReportsList] = useState([])
    const [jobDatas, setJobDatas] = useState([])
    const [jobPostingName, setJobPostingName] = useState("")
    const [showTableLoader, setShowTableLoader] = useState(false)
    const [filteredEventDatas, setFilteredEventDatas] = useState([])
    const [selectedFromDate, setSelectedFromDate] = useState(null)
    const [selectedToDate, setSelectedToDate] = useState(null)
    const [triggerApi, setTriggerApi] = useState(false)
    const [searchKeyword, setSearchKeyword] = useState("")
    const [open, setOpen] = useState(false)
    const [showClearFilter, setShowClearFilter] = useState(false)
    const [downloadProgress, setDownloadProgress] = useState(null);
    const [dashBoardDisabled, setDashBoardDisabled] = useState(false)


    const handleOpen = () => {
        if (chips.length === 0) {
            setSelectedClient("")
            setSelectedJobPosting("")
            setJobPostingName("")
            setFilteredEventDatas([])
            setSelectedEvent([])
            setSelectedFromDate(null)
            setSelectedToDate(null)
            setChips([])
            setOpen(true)
        } else {
            setOpen(true)
        }
    }

    const handleClose = () => {
        setOpen(false)

    }

    const handleSearchKeywordChange = (e) => {
        const value = e.target.value
        setSearchKeyword(value)
        setPage(1)
        setTriggerApi(true)
    }

    const handlePageChange = (e, newPage) => {
        setPage(newPage)
        setTriggerApi(true)
    }

    const handleRowsPerPageChange = (e) => {
        const value = +e.target.value
        setRowsPerPage(value)
        setPage(0)
    }

    const [getManageEventList] = useGetManageEventListMutation()
    const { data: clientDropdown } = useGetClientDropdownQuery()
    const { data: eventsDropdown } = useEventDropDownQuery()
    const [jobDescForParticularClient] = useJobDescForParticularClientMutation()
    const [getPositionEventReport] = useGetPositionEventReportMutation()
    const { Snackbar } = useContext(SnackbarContext)

    const handleFromDateChange = (value) => {
        setSelectedFromDate(value)

        if (selectedToDate && value >= selectedToDate) {
            setSelectedToDate(null)
        }
    }

    const handleToDateChange = (value) => {
        setSelectedToDate(value)
    }

    const getNextDay = (fromDate) => {
        if (!fromDate) {
            return null
        }
        return dayjs(fromDate)?.add(1, 'day')
    }

    const handleClientNameChange = (value) => {
        setSelectedClient(value)

        const name = clientDropdown?.response?.clientList?.find((name) => name?.clientName === value)
        setSelectedClientId([name?.clientId])
    }

    const handleEventsChange = (e) => {
        const value = e.target.value
        setSelectedEvent(value)
    }

    const [chips, setChips] = useState([])

    const letsFilterDatas = () => {
        const updatedChips = [
            selectedClient && {
                label: selectedClient,
                onDelete: () => {
                    setSelectedClient("");
                    setSelectedJobPosting("");
                    setJobPostingName("");
                    setFilteredEventDatas([]);
                    setSelectedEvent([]);
                    setTriggerApi(true);
                    setChips(prevChips => prevChips.filter(chip => chip.label !== selectedClient));
                }
            },
            jobPostingName && {
                label: jobPostingName,
                onDelete: () => {
                    setSelectedJobPosting("");
                    setJobPostingName("");
                    setFilteredEventDatas([]);
                    setSelectedEvent([]);
                    setTriggerApi(true);
                    setChips(prevChips => prevChips.filter(chip => chip.label !== jobPostingName));
                }
            },
            ...filteredEventDatas?.map(eventItem => ({
                label: eventItem?.event,
                onDelete: () => {
                    setSelectedEvent(prev => prev.filter(id => id !== eventItem?.eventTypeId));
                    setFilteredEventDatas(prev => prev.filter(name => name?.event !== eventItem?.event));
                    setTriggerApi(true);
                    setChips(prevChips => prevChips.filter(chip => chip.label !== eventItem?.event));
                }
            })),
            selectedFromDate && {
                label: dayjs(selectedFromDate)?.format('DD-MM-YYYY'),
                onDelete: () => {
                    setSelectedFromDate(null);
                    setSelectedToDate(null);
                    setTriggerApi(true);
                    setChips(prevChips => prevChips.filter(chip => chip.label !== dayjs(selectedFromDate)?.format('DD-MM-YYYY')));
                }
            },
            selectedToDate && {
                label: dayjs(selectedToDate)?.format('DD-MM-YYYY'),
                onDelete: () => {
                    setSelectedToDate(null);
                    setTriggerApi(true);
                    setChips(prevChips => prevChips.filter(chip => chip.label !== dayjs(selectedToDate)?.format('DD-MM-YYYY')));
                }
            }
        ]
            .filter(Boolean);
        setChips(updatedChips);
        setTriggerApi(true);
        setShowClearFilter(true);
    };



    useEffect(() => {
        const eventNames = eventsDropdown?.response?.filter((item) => (
            selectedEvent?.includes?.(item?.eventTypeId)
        ))
        setFilteredEventDatas(eventNames || [])
    }, [selectedEvent])

    const handleJobPostingsChange = (value) => {
        setSelectedJobPosting(value)

        const jobName = jobDatas?.find((id) => id?.positionId === value)
        setJobPostingName(jobName?.positionDesc)
    }



    useEffect(() => {
        const getJobPostingsData = async () => {
            try {
                const payload = {
                    clientIds: selectedClientId || []
                }
                const response = await jobDescForParticularClient(payload).unwrap()
                if (response?.status === 200) {
                    setJobPostingArr(response?.response)
                }

                if (selectedClient) {
                    const jobName = response?.response?.filter((name) => name?.clientName === selectedClient)
                    setJobDatas(jobName)
                }
            } catch (err) {
                Snackbar('Network error', 'error')
            }
        }
        getJobPostingsData()
    }, [jobDescForParticularClient, selectedClient])

    const getTableDatas = async () => {
        try {
            const payload = {
                clientName: searchKeyword ? searchKeyword : selectedClient ? selectedClient : null,
                eventTypeId: selectedEvent || [],
                page: (page - 1),
                positionId: selectedJobPosting || null,
                size: rowsPerPage,
                fromDate: selectedFromDate ? dayjs(selectedFromDate)?.format('YYYY-MM-DD') : null,
                toDate: selectedToDate ? dayjs(selectedToDate)?.format('YYYY-MM-DD') : null
            }

            setShowTableLoader(true)
            const response = await getManageEventList(payload).unwrap()
            setShowTableLoader(false)
            if (response?.status === 200) {
                setManageEventsReportsList(response?.response[0]?.list || [])
                setTotalCount(response?.response[0]?.count)
            }
        } catch (err) {
            Snackbar('Network error', 'error')
            setShowTableLoader(false)
        }
    }

    useEffect(() => {
        getTableDatas()
    }, [])

    useEffect(() => {
        if (triggerApi) {
            getTableDatas()
            handleClose()
            setTriggerApi(false)
        }

    }, [getManageEventList, searchKeyword, selectedClient, selectedEvent, selectedJobPosting, page, rowsPerPage, selectedFromDate, selectedToDate, triggerApi])

    const handleExcelDownload = async () => {
        try {
            setDownloadProgress(0); // start at 0%

            const payload = {
                clientName: selectedClient || null,
                eventTypeId: selectedEvent || [],
                positionId: selectedJobPosting || null,
                fromDate: selectedFromDate ? dayjs(selectedFromDate)?.format('YYYY-MM-DD') : null,
                toDate: selectedToDate ? dayjs(selectedToDate)?.format('YYYY-MM-DD') : null,
            };

            const token = localStorage.getItem('token');
            setDashBoardDisabled(true)
            const response = await fetch(`${window.REACT_APP_BASE_URL}getPositionEventReport`, {
                method: "POST",
                body: JSON.stringify(payload),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });
            setDashBoardDisabled(false)
            if (!response.ok) throw new Error("Network response was not ok");

            const contentLength = response.headers.get('Content-Length');
            const total = contentLength ? parseInt(contentLength, 10) : null;

            const reader = response.body.getReader();
            const chunks = [];
            let receivedLength = 0;

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                chunks.push(value);
                receivedLength += value.length;

                if (total) {
                    const progress = Math.round((receivedLength / total) * 100);
                    setDownloadProgress(progress);
                } else {
                    // fallback if content length is not available
                    setDownloadProgress((prev) => Math.min((prev || 0) + 3, 95)); // smaller steps, max 95%
                }
            }

            const blob = new Blob(chunks, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = "Manage Events Report.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            setDownloadProgress(100);
        } catch (err) {
            Snackbar('Network error', 'error');
        } finally {
            setTimeout(() => setDownloadProgress(null), 1000);
        }
    };




    const handleSubmitProfNav = (item) => {
        const url = `/submitprofiles/${item?.positionId}?clientName=${encodeURIComponent(item?.clientName)}`;
        window.open(url, '_blank')
    }

    const handleCandidateNav = (item) => {
        window.open(`/editcandidateprofile/${item?.candidateId}`)
    }


    const handleClearFilterChange = () => {
        setSelectedClient("")
        setSelectedJobPosting("")
        setJobPostingName("")
        setFilteredEventDatas([])
        setSelectedEvent([])
        setTriggerApi(true)
        setSelectedFromDate(null)
        setSelectedToDate(null)
        setShowClearFilter(false)
        setChips([])
    }

    const filteredTableDatas = manageEventsReportsList?.filter((item) => {
        return (
            (item?.clientName?.toLowerCase()?.includes(searchKeyword?.toLowerCase())) ||
            (item?.profileName?.toLowerCase()?.startsWith(searchKeyword?.toLowerCase()))
        )
    })

    return (
        <Box className='container'>
            <Grid2 item sx={{ display: 'flex', alignItems: 'center', color: '#6941C6', gap: '4px', cursor: 'pointer', width: '40px', marginBottom: '20px' }} onClick={() => navigate(-1)}>
                <ArrowBackIcon sx={{ fontSize: '17px' }} />
                <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>Back</Typography>
            </Grid2>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                <Typography className="title">Manage Events Status Report</Typography>

                <div style={{ display: 'flex', gap: '30px' }}>
                    <TextField
                        value={searchKeyword}
                        onChange={handleSearchKeywordChange}
                        className="textfields"
                        sx={{ width: '230px !important' }}
                        placeholder="Search"
                        slotProps={{
                            input: {
                                startAdornment: <SearchIconLg style={{ paddingRight: '5px' }} />
                            }
                        }}
                    />
                    {
                        manageEventsReportsList?.length > 0 && (
                            <Tooltip
                                title={dashBoardDisabled === true && ('Please Wait...')}
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            backgroundColor: 'black',
                                            color: 'white',
                                            '& .MuiTooltip-arrow': {
                                                color: 'black',
                                            }
                                        }
                                    }
                                }}
                                arrow
                            >
                                <MUIButton
                                    title={downloadProgress !== null ? `Downloading... ${downloadProgress}%` : 'Download'}
                                    disabled={dashBoardDisabled}
                                    startIcon={<DownloadIcon stroke={'white'} />}
                                    sx={{ color: 'white', border: '1px solid #D6BBFB', width: '200px' }}
                                    onClick={handleExcelDownload}
                                />
                            </Tooltip>
                        )
                    }
                </div>
            </div>
            {/* More Filters */}
            <Grid2 item>
                <Dialog
                    open={open}
                    scroll="paper"
                    maxWidth='md'
                    className="sidePopup"
                >
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '18px', fontWeight: 550 }}>
                        Filters
                        <CloseIcon sx={{ color: '#717680', cursor: 'pointer' }} onClick={handleClose} />
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <Grid2 container sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Grid2 item container sx={{ display: 'flex', flexDirection: 'column', width: '100%' }} gap={2}>
                                    <Grid2 item>
                                        <InputLabel className="inputlabels">Client Name</InputLabel>
                                        <Dropdown
                                            placeholder='Select Client'
                                            value={selectedClient || ""}
                                            onChange={handleClientNameChange}
                                            options={clientDropdown?.response?.clientList || []}
                                            valueKey='clientName'
                                            labelKey='clientName'
                                        />
                                    </Grid2>

                                    <Grid2 item>
                                        <InputLabel className="inputlabels">Job Posting</InputLabel>
                                        <Dropdown
                                            onChange={handleJobPostingsChange}
                                            value={selectedJobPosting || ""}
                                            options={selectedClient && jobPostingArr || []}
                                            valueKey='positionId'
                                            labelKey='positionDesc'
                                            placeholder='Select Job Posting'
                                        />
                                    </Grid2>

                                    <Grid2 item>
                                        <InputLabel className="inputlabels">Events</InputLabel>
                                        <Select
                                            size="small"
                                            multiple
                                            sx={{ width: '100%', height: '35px', fontSize: '14px', borderRadius: '10px' }}
                                            value={selectedEvent || []}
                                            onChange={handleEventsChange}
                                            displayEmpty
                                            renderValue={(selected) => (
                                                <>
                                                    {selected?.length < 1 ? (
                                                        <p style={{ color: '#a2a2a2' }}>Select Events</p>
                                                    ) : (
                                                        `${selected?.length} items Selected`
                                                    )}
                                                </>
                                            )}
                                            IconComponent={KeyboardArrowDownIcon}
                                        >
                                            <MenuItem className="menuItemsPlaceholder" disabled>Select Events</MenuItem>
                                            {selectedJobPosting && eventsDropdown?.response?.map((item) => (
                                                <MenuItem key={item?.eventTypeId} value={item?.eventTypeId} sx={{ margin: '5px', borderRadius: '7px', fontSize: '14px' }}>
                                                    <Checkbox
                                                        checked={selectedEvent?.includes(item?.eventTypeId)}
                                                        sx={{
                                                            '& .MuiSvgIcon-root': { fontSize: 18 }, padding: 0.5,
                                                            '&.Mui-checked': {
                                                                color: '#7F56D9',
                                                            },
                                                        }}
                                                    />
                                                    {item?.event}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid2>
                                </Grid2>
                                <Grid2 item container sx={{ display: 'flex', flexDirection: 'column', width: '100%', marginTop: '15px' }} gap={2}>
                                    <Grid2 item>
                                        <InputLabel className="inputlabels">From Date</InputLabel>
                                        <MuiDatePicker
                                            value={selectedFromDate}
                                            onChange={handleFromDateChange}
                                            slots={{
                                                openPickerIcon: CalendarIcon
                                            }}
                                            sx={{
                                                "& .MuiInputBase-input": {
                                                    fontSize: '14px'
                                                },
                                                "& .MuiSvgIcon-root": {
                                                    fontSize: '20px'
                                                },
                                                width: '100%'
                                            }}
                                            slotProps={{
                                                textField: {
                                                    size: 'small',
                                                    placeholder: 'Choose From Date',
                                                    InputProps: {
                                                        sx: { borderRadius: '10px' }
                                                    }
                                                }
                                            }}
                                            format="DD-MM-YYYY"
                                        />
                                    </Grid2>

                                    <Grid2 item>
                                        <InputLabel className="inputlabels">To Date</InputLabel>
                                        <MuiDatePicker
                                            value={selectedToDate}
                                            disabled={selectedFromDate === null}
                                            onChange={handleToDateChange}
                                            sx={{
                                                "& .MuiInputBase-input": {
                                                    fontSize: '14px'
                                                },
                                                "& .MuiSvgIcon-root": {
                                                    fontSize: '20px'
                                                },
                                                width: '100%'
                                            }}
                                            slots={{
                                                openPickerIcon: CalendarIcon
                                            }}
                                            slotProps={{
                                                textField: {
                                                    size: 'small',
                                                    placeholder: 'Choose To Date',
                                                    InputProps: {
                                                        sx: { borderRadius: '10px' }
                                                    }
                                                }
                                            }}
                                            minDate={getNextDay(selectedFromDate) || null}
                                            maxDate={dayjs()}
                                            format="DD-MM-YYYY"
                                            disableOpenPicker={!selectedFromDate}
                                        />
                                    </Grid2>
                                </Grid2>
                            </Grid2>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Grid2 item sx={{ width: '100%', display: 'flex', justifyContent: 'center', gap: '20px' }}>

                            <MUICancelButton title='Cancel' onClick={handleClose} sx={{ width: '42%' }} />
                            <MUIButton title='Apply' sx={{ width: '42%' }}
                                onClick={letsFilterDatas}
                            />
                        </Grid2>
                    </DialogActions>
                </Dialog>
            </Grid2>
            <Grid2 container sx={{ marginTop: '15px' }}>
                <Paper sx={{ width: '100%', overflow: 'auto', border: '1px solid #E9EAEB' }} elevation={0}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={100}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div>
                                            {
                                                chips?.map((item, index) => {
                                                    return (
                                                        item?.label && item?.label?.length > 0 && (
                                                            <Chip
                                                                className="Chip"
                                                                key={index}
                                                                label={item?.label}
                                                                size="small"
                                                                variant="outlined"
                                                                onDelete={item?.onDelete}
                                                                deleteIcon={<CloseIcon sx={{ color: '#414651 !important' }} />}
                                                            />
                                                        )
                                                    )
                                                })

                                            }
                                        </div>
                                        <div style={{ display: 'flex', gap: '14px' }}>
                                            <MUICancelButton title='More Filters' onClick={handleOpen} startIcon={<FilterListIcon sx={{ fontSize: '20px !important' }} />} sx={{ color: '#6941C6', borderColor: '#D6BBFB', fontWeight: 600, width: '130px' }} />
                                            {chips?.length > 0 ? (
                                                <MUICancelButton title='Clear Filter' sx={{ width: '100px' }} onClick={handleClearFilterChange} />
                                            ) : ("")
                                            }
                                        </div>
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="tableHeadersCell">Client</TableCell>
                                <TableCell className="tableHeadersCell">Job</TableCell>
                                <TableCell className="tableHeadersCell">Candidate</TableCell>
                                <TableCell className="tableHeadersCell">Status Date</TableCell>
                                <TableCell className="tableHeadersCell">Status Date</TableCell>
                                <TableCell className="tableHeadersCell">Remarks</TableCell>
                            </TableRow>
                        </TableHead>

                        {!showTableLoader ? (
                            filteredTableDatas?.length > 0 ? (
                                <TableBody>
                                    {filteredTableDatas?.map((item, index) => (
                                        <TableRow
                                            key={index}
                                            sx={{
                                                backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                '&:hover': { backgroundColor: '#f1f1f1' },
                                            }}
                                        >
                                            <TableCell className="tableBodyCell">{item?.clientName}</TableCell>
                                            <TableCell className="tableBodyCell"> <span style={{ color: '#7F56D9', cursor: 'pointer' }} onClick={() => handleSubmitProfNav(item)}> {item?.positionId} </span> {item?.positionDesc}</TableCell>
                                            <TableCell className="tableBodyCell"> <span style={{ color: '#7F56D9', cursor: 'pointer' }} onClick={() => handleCandidateNav(item)}> {item?.candidateId} </span> {item?.profileName}</TableCell>
                                            <TableCell className="tableBodyCell">{item?.currentEventType ? item?.currentEventType : '-'}</TableCell>
                                            <TableCell className="tableBodyCell">{item?.eventDate ? dayjs(item?.eventDate).format('DD-MM-YYYY') : '-'}</TableCell>
                                            <TableCell className="tableBodyCell">{item?.remarks ? item?.remarks : '-'}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            ) : (
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={8}>
                                            <Typography className="emptydatas">No Data Found</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            )
                        ) : (
                            <TableRow>
                                <TableCell colSpan={8}>
                                    <Box className='tableloader'>
                                        <TableLoader />
                                    </Box>
                                </TableCell>
                            </TableRow>
                        )}
                        {Math.ceil(totalCount / rowsPerPage) > 1 && (
                            <TableRow>
                                <TableCell colSpan={100}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <MUICancelButton
                                            title='Previous'
                                            startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                            onClick={() => handlePageChange(null, page - 1)}
                                            disabled={page === 1}
                                            sx={{ height: '36px' }}
                                        />

                                        <Pagination
                                            page={page}
                                            onChange={handlePageChange}
                                            count={Math.ceil(totalCount / rowsPerPage)}
                                            shape="rounded"
                                            siblingCount={3}
                                            boundaryCount={3}
                                            hidePrevButton
                                            hideNextButton
                                        />

                                        <MUICancelButton
                                            title='Next'
                                            startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(totalCount / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                            disabled={page === Math.ceil(totalCount / rowsPerPage)}
                                            onClick={() => handlePageChange(null, page + 1)}
                                            sx={{ height: '36px' }}
                                        />
                                    </div>
                                </TableCell>
                            </TableRow>
                        )}
                    </Table>
                </Paper>

                {/* <Table>
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                className="tablepagination"
                                page={page}
                                rowsPerPage={rowsPerPage}
                                onPageChange={handlePageChange}
                                onRowsPerPageChange={handleRowsPerPageChange}
                                rowsPerPageOptions={[10, 20, 50]}
                                count={totalCount || 0}
                            />
                        </TableRow>
                    </TableFooter>
                </Table> */}
            </Grid2>
        </Box>
    )
}

export default ManageEventsReports